import './App.css';

// https://lucide.dev/
import {
  Clock,
  Award,
  Users,
  Menu,
  X,
  Gem,
} from 'lucide-react'
import React, { useState } from 'react'

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-sm fixed w-full z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex-shrink-0 flex items-center">
              <span className="text-[#2C5530] text-xl font-bold">Golfing</span>
            </div>

            <div className="hidden md:block">
              <div className="ml-10 flex items-center space-x-8">
                <a className="text-gray-700 hover:text-[#2C5530] transition-colors" href="#hero-section">
                  Home
                </a>
                <a className="text-gray-700 hover:text-[#2C5530] transition-colors" href="#services-section">
                  Services
                </a>
                <a className="text-gray-700 hover:text-[#2C5530] transition-colors" href="#about-section">
                  About
                </a>
              </div>
            </div>

            <div className="md:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="text-gray-700 hover:text-[#2C5530]"
              >
                {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile menu */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
              <a className="block px-3 py-2 text-gray-700 hover:text-[#2C5530]" href="#hero-section">
                Home
              </a>
              <a className="block px-3 py-2 text-gray-700 hover:text-[#2C5530]" href="#services-section">
                Services
              </a>
              <a className="block px-3 py-2 text-gray-700 hover:text-[#2C5530]" href="#about-section">
                About
              </a>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <div id='hero-section'
        className="relative pt-16 pb-32 flex content-center items-center justify-center"
        style={{
          minHeight: '95vh',
          backgroundImage:
            "url('/images/hero.jpeg')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute top-0 w-full h-full bg-black opacity-40"></div>
        <div className="container relative mx-auto">
          <div className="items-center flex flex-wrap">
            <div className="w-full lg:w-6/12 px-4 ml-auto mr-auto text-center">
              <h1 className="text-white font-bold text-5xl mb-6">
                Effortless Golf Booking
              </h1>
              <p className="mt-4 text-lg text-white">
                Smart, fast, and reliable tee time reservations.
              </p>
              {/* todo */}
              <button className="mt-8 bg-[#2C5530] text-white font-bold py-3 px-8 rounded-lg hover:bg-[#234226] transition-colors"
                onClick={() => (window.location.href = "https://play.google.com/store/apps/details?id=com.santak.golfing")}
              >
                Let’s Book
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <section id='services-section' className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap">
            <div className="lg:pt-0 pt-0 w-full md:w-4/12 px-4 text-center">
              <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg p-8">
                <div className="px-4 py-5 flex-auto">
                  <div className="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-[#2C5530]">
                    <Award />
                  </div>
                  <h6 className="text-xl font-semibold">
                    Malaysia's Most Professional Booking App
                  </h6>
                  <p className="mt-2 mb-4 text-gray-600">
                    Experience seamless golf bookings with Malaysia's top-rated platform, designed for golfers who value professionalism and convenience.
                  </p>
                </div>
              </div>
            </div>

            <div className="lg:pt-0 pt-0 w-full md:w-4/12 px-4 text-center">
              <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg p-8">
                <div className="px-4 py-5 flex-auto">
                  <div className="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-[#2C5530]">
                    <Gem />
                  </div>
                  <h6 className="text-xl font-semibold">Premium & Secure Booking</h6>
                  <p className="mt-2 mb-4 text-gray-600">
                    Enjoy peace of mind with our premium and secure booking system, ensuring a hassle-free experience every time.
                  </p>
                </div>
              </div>
            </div>

            <div className="lg:pt-0 pt-0 w-full md:w-4/12 px-4 text-center">
              <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg p-8">
                <div className="px-4 py-5 flex-auto">
                  <div className="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-[#2C5530]">
                    <Clock />
                  </div>
                  <h6 className="text-xl font-semibold">Save Time with Quick Booking</h6>
                  <p className="mt-2 mb-4 text-gray-600">
                    Effortlessly book your golf sessions in seconds and make the most of your day.
                  </p>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id='about-section' className="relative py-20">
        <div className="container mx-auto px-4">
          <div className="items-center flex flex-wrap">
            <div className="w-full md:w-6/12 ml-auto mr-auto px-4">
              <div className="md:pr-12">
                <div className="text-[#2C5530] p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-gray-100">
                  <Users size={32} />
                </div>
                <h3 className="text-3xl font-semibold">About Our Service</h3>
                <p className="mt-4 text-lg leading-relaxed text-gray-600">
                  Inspired by the rich history of Malaysian golf, including the prestigious Malaysian Open since 1962,
                  we have become a trusted name in online golf booking. Our platform offers fast and secure services,
                  making it easier than ever to reserve your next tee time.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="relative bg-gray-100 pt-8 pb-6">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap">
            <div className="w-full lg:w-6/12 px-4">
              <h4 className="text-2xl font-semibold text-[#2C5530]">
                Follow Us
              </h4>
              <div className="mt-6 flex space-x-4">
                <a className="text-gray-600 hover:text-[#2C5530] transition-colors" href="https://www.facebook.com/profile.php?id=61555122449054">
                  <svg width={24} height={24} role="img" viewBox="0 0 24 24" fill='#707070' xmlns="http://www.w3.org/2000/svg"><title>Facebook</title><path d="M9.101 23.691v-7.98H6.627v-3.667h2.474v-1.58c0-4.085 1.848-5.978 5.858-5.978.401 0 .955.042 1.468.103a8.68 8.68 0 0 1 1.141.195v3.325a8.623 8.623 0 0 0-.653-.036 26.805 26.805 0 0 0-.733-.009c-.707 0-1.259.096-1.675.309a1.686 1.686 0 0 0-.679.622c-.258.42-.374.995-.374 1.752v1.297h3.919l-.386 2.103-.287 1.564h-3.246v8.245C19.396 23.238 24 18.179 24 12.044c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.628 3.874 10.35 9.101 11.647Z" /></svg>
                </a>
                {/* todo */}
                {/* <a className="text-gray-600 hover:text-[#2C5530] transition-colors" href="/">
                  <svg width={24} height={24} role="img" viewBox="0 0 24 24" fill='#707070' xmlns="http://www.w3.org/2000/svg"><title>X</title><path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z" /></svg>
                </a>
                <a className="text-gray-600 hover:text-[#2C5530] transition-colors" href="/">
                  <svg width={24} height={24} role="img" viewBox="0 0 24 24" fill='#707070' xmlns="http://www.w3.org/2000/svg"><title>Instagram</title><path d="M7.0301.084c-1.2768.0602-2.1487.264-2.911.5634-.7888.3075-1.4575.72-2.1228 1.3877-.6652.6677-1.075 1.3368-1.3802 2.127-.2954.7638-.4956 1.6365-.552 2.914-.0564 1.2775-.0689 1.6882-.0626 4.947.0062 3.2586.0206 3.6671.0825 4.9473.061 1.2765.264 2.1482.5635 2.9107.308.7889.72 1.4573 1.388 2.1228.6679.6655 1.3365 1.0743 2.1285 1.38.7632.295 1.6361.4961 2.9134.552 1.2773.056 1.6884.069 4.9462.0627 3.2578-.0062 3.668-.0207 4.9478-.0814 1.28-.0607 2.147-.2652 2.9098-.5633.7889-.3086 1.4578-.72 2.1228-1.3881.665-.6682 1.0745-1.3378 1.3795-2.1284.2957-.7632.4966-1.636.552-2.9124.056-1.2809.0692-1.6898.063-4.948-.0063-3.2583-.021-3.6668-.0817-4.9465-.0607-1.2797-.264-2.1487-.5633-2.9117-.3084-.7889-.72-1.4568-1.3876-2.1228C21.2982 1.33 20.628.9208 19.8378.6165 19.074.321 18.2017.1197 16.9244.0645 15.6471.0093 15.236-.005 11.977.0014 8.718.0076 8.31.0215 7.0301.0839m.1402 21.6932c-1.17-.0509-1.8053-.2453-2.2287-.408-.5606-.216-.96-.4771-1.3819-.895-.422-.4178-.6811-.8186-.9-1.378-.1644-.4234-.3624-1.058-.4171-2.228-.0595-1.2645-.072-1.6442-.079-4.848-.007-3.2037.0053-3.583.0607-4.848.05-1.169.2456-1.805.408-2.2282.216-.5613.4762-.96.895-1.3816.4188-.4217.8184-.6814 1.3783-.9003.423-.1651 1.0575-.3614 2.227-.4171 1.2655-.06 1.6447-.072 4.848-.079 3.2033-.007 3.5835.005 4.8495.0608 1.169.0508 1.8053.2445 2.228.408.5608.216.96.4754 1.3816.895.4217.4194.6816.8176.9005 1.3787.1653.4217.3617 1.056.4169 2.2263.0602 1.2655.0739 1.645.0796 4.848.0058 3.203-.0055 3.5834-.061 4.848-.051 1.17-.245 1.8055-.408 2.2294-.216.5604-.4763.96-.8954 1.3814-.419.4215-.8181.6811-1.3783.9-.4224.1649-1.0577.3617-2.2262.4174-1.2656.0595-1.6448.072-4.8493.079-3.2045.007-3.5825-.006-4.848-.0608M16.953 5.5864A1.44 1.44 0 1 0 18.39 4.144a1.44 1.44 0 0 0-1.437 1.4424M5.8385 12.012c.0067 3.4032 2.7706 6.1557 6.173 6.1493 3.4026-.0065 6.157-2.7701 6.1506-6.1733-.0065-3.4032-2.771-6.1565-6.174-6.1498-3.403.0067-6.156 2.771-6.1496 6.1738M8 12.0077a4 4 0 1 1 4.008 3.9921A3.9996 3.9996 0 0 1 8 12.0077" /></svg>
                </a> */}
              </div>
            </div>
          </div>
          <hr className="my-6 border-gray-300" />
          <div className="flex flex-wrap items-center md:justify-between justify-center">
            <div className="w-full px-4 mx-auto text-center">
              <div className="text-sm text-gray-600">
                Copyright © {new Date().getFullYear()} Golfing. All rights reserved. Operated by Santa K Sdn. Bhd.
              </div>

              <a className="text-sm text-gray-600 hover:text-[#2C5530] transition-colors policy-link" href="/privacy_policy.html">
                [ Privacy Policy |
              </a>

              <a className="text-sm text-gray-600 hover:text-[#2C5530] transition-colors policy-link" href="/term_service.html">
                &nbsp;Terms of Service ]
              </a>

            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default App;
